export const get_ref_color = (Impact_Factor_2022)=>{
  let color = '';
  if(['NA', null, ''].indexOf(Impact_Factor_2022) > -1) color = '#A6A6A6';
  else if (Impact_Factor_2022 >= 0 && Impact_Factor_2022 <=5) color = '#5B9BD5';
  else if (Impact_Factor_2022 > 5 && Impact_Factor_2022 <= 10) color = '#70AD47';
  else if (Impact_Factor_2022 > 10 && Impact_Factor_2022 <= 20) color = '#FFC000';
  else if(Impact_Factor_2022 > 20) color = '#FF0000';
  console.log('xxxxx====', Impact_Factor_2022, ['NA', null, ''].indexOf(Impact_Factor_2022) > -1);
  return color
};
// 格式化文件大小（字节转MB/KB）
export const formatFileSize = (size) => {
  if(isNaN(size)) return '';
  if (size < 1024) return size + ' B';
  if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB';
  if (size < 1024 * 1024 * 1024) return (size / 1024 / 1024).toFixed(2) + ' MB';
  return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
};